import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const SvgRemoteJob = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 502.685 502.685"
    {...props}
  >
    <path d="M383.96 261.729V118.564H232.123V17.375H0V338.09h232.123V147.296h123.104v114.39L236.524 380.433h45.277V485.31h175.651V380.433h45.234zM33.888 51.241h62.577v37.166H33.888zm0 70.407h62.577v37.21H33.888zm108.76 204.448h-57.12V221.262h57.098zm51.597-167.26H131.69v-37.188h62.555zm0-70.428H131.69V51.241h62.555zm202.291 387.756h-52.115v-91.611h52.115z" />
  </svg>
);
const Memo = memo(SvgRemoteJob);
export default Memo;
